export const isPasswordValidError = (value: string) => {
    const re = /.{6,32}$/i;
    if (!re.test(value)) return 'Not enough characters';
    return false;
};

export const required = (value: string) => (value ? undefined : 'Required');
export const validateCode = (values: string) => (!/^[0-9]{6}$/i.test(values) ? 'Invalid code' : undefined);

export const validatePhone = (values: string) => {
    if (values === '+' || !values) {
        return 'This field is required';
    } else if (!/^[0-9+-]{6,19}$/i.test(values)) {
        return 'Invalid phone number';
    }
};

export const validateInvite = (values: string) => {
    const charsAllowed = /^[a-zA-Z0-9\-~]{1,20}$/;
    if (!values.length) return false;
    return !charsAllowed.test(values) ? 'Invalid code' : undefined;
};

export const validateEmail = (values: string) => {
    // FIXME: validating it like this is not a good idea
    const re =
        // eslint-disable-next-line security/detect-unsafe-regex
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(values).toLowerCase()) ? 'Incorrect email' : undefined;
};

/**
 * @param password
 * @description Tests password to satisfy following requirements:
 * <br/>&nbsp; - characters outside the range 0x21 - 0x7E are not allowed.
 * <br/>&nbsp; - length 8-32 chars.
 * <br/>&nbsp; - at least one lowercase letter;
 * <br/>&nbsp; - at least one uppercase letter;
 * <br/>&nbsp; - at least one digit;
 * <br/>&nbsp; - optional special symbol;
 * <br> Returns undefined for a valid password, otherwise returns static error text
 */
export const validateNewPassword = (password: string) => {
    const validChars = /^[\x21-\x7E]+$/;
    const hasLowercase = /[a-z]/;
    const hasUppercase = /[A-Z]/;
    const hasDigit = /\d/;
    const length = /^.{8,32}$/;

    const regexps = [validChars, hasLowercase, hasUppercase, hasDigit, length];
    const validateResults = regexps.map(regexp => regexp.test(password));
    return validateResults.every(Boolean) ? undefined : 'Invalid password';
};
